import { Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAdminsContext } from '@/contexts/AdminsContext'
import { ElectionsProvider } from '@/contexts/ElectionsContext'
import { useAuth } from '@/plugins/auth'
import { BodyStack } from '@/styled/components'

import AdminVotes from './AdminVotes'

const Component: React.FC = () => {
  const { t } = useTranslation()
  const { address } = useAuth()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const navigate = useNavigate()
  const [loaded, setLoaded] = useState(false)

  const { isLoading, admins } = useAdminsContext()

  // On load check admins and redirect back to elections page if not admin
  useEffect(() => {
    if (
      address &&
      !isLoading &&
      !admins.map(a => a.toLowerCase()).includes(address.toLowerCase())
    ) {
      navigate('/elections')
    } else {
      setLoaded(true)
    }
  }, [address, isLoading, admins, navigate])

  return (
    <ElectionsProvider>
      <BodyStack>
        <Title order={isMobile ? 3 : 2}>
          {t('components.elections.admin.title', 'Elections Admin')}
        </Title>
        {loaded && <AdminVotes />}
      </BodyStack>
    </ElectionsProvider>
  )
}

Component.displayName = 'GovernanceAdmin'

// eslint-disable-next-line import/prefer-default-export
export { Component }
